import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import MobileStepper from '../../common/MobileStepper';
import PanelTemplate from '../../common/PanelTemplate';

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 'bold',
    fontSize: 18,
    color: '#4D4F5C'
  },
  newsList: {
    display: 'flex',
    flexDirection: 'column'
  }
}));

const tutorialSteps = [
  {
    title: 'GTM Solar',
    description:
      'onsectetur adipiscing elit. Donec ultricies quam sit amet lorem lacinia, non iaculis ur na ultricies. Nulla sed ex eu diam vulputate sagittis. Suspendisse potenti. Cras in nisl accumsan varius nisi blandit, porttitor elit. Pellentesque nec lacinia metus. Fusce quis nibh nisi. Vivamus hendrerit, diam nec aliquam maximus,'
  },
  {
    title: 'Test',
    description:
      'Homeowners contact Enphase for new installs, upgrades and ongoing system maintenance. As an Enphase partner, you now have the opportunity to serve these homeowners through the Enphase Leads Program, which will match you to prospective homeowners.​'
  }
];

const IndustryNews = props => {
  const classes = useStyles();
  const stepperContent = content => (
    <Box className={classes.newsList}>
      <Typography className={classes.title}>{content.title}</Typography>
      <Typography>{content.description}</Typography>
    </Box>
  );
  return (
    <PanelTemplate header="News Board" boxShadow>
      <MobileStepper list={tutorialSteps} stepperContent={stepperContent} />
    </PanelTemplate>
  );
};

export default IndustryNews;
